var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCondashSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "connection-check-icon",
    clipPath: "url(#clip0_10176_32559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.80765 19.7788L4.22187 21.1931L7.05029 18.3646L8.46451 19.7788C9.24556 20.5599 10.5119 20.5599 11.2929 19.7788L14.8285 16.2433L7.7574 9.17224L4.22187 12.7078C3.44082 13.4888 3.44082 14.7552 4.22187 15.5362L5.63608 16.9504L2.80765 19.7788ZM9.87872 18.3646L5.63608 14.122L7.7574 12.0007L12 16.2433L9.87872 18.3646Z",
    fill: "#0EAB4E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1924 4.22311L19.7782 2.8089L16.9498 5.63733L15.5356 4.22311C14.7545 3.44206 13.4882 3.44206 12.7071 4.22311L9.17159 7.75865L16.2427 14.8297L19.7782 11.2942C20.5592 10.5131 20.5592 9.2468 19.7782 8.46575L18.364 7.05154L21.1924 4.22311ZM14.1213 5.63733L18.364 9.87997L16.2427 12.0013L12 7.75865L14.1213 5.63733Z",
    fill: "#0EAB4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0096 8.74835L12.4238 10.1626L9.87865 12.7077L8.46443 11.2935L11.0096 8.74835Z",
    fill: "#0EAB4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9362 11.4787L15.3505 12.8929L12.7071 15.5363L11.2929 14.1221L13.9362 11.4787Z",
    fill: "#0EAB4E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10176_32559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondashSuccess);
export default __webpack_public_path__ + "static/media/condash-success.3981c8953128f2c265d9ade5b56e8621.svg";
export { ForwardRef as ReactComponent };